import request from '@/Utils/request.js';
//用户登录
export function UserLogin (params) {
    return request({
      url: '/api/User/GetToken',
      method: 'post',
      params: params
    });
}
//用户注册
export function UserRegister (params,data) {
  return request({
    url: '/api/User/UserRegistration',
    method: 'post',
    params: params,
    data:data
  });
}

//刷新Token
export function RefreshToken () {
  return request({
    url: '/api/User/RefreshToken',
    method: 'get'
  });
}

//忘记密码
export function ForgetPwd (params,data) {
  return request({
    url: '/api/User/ForgetPwd',
    method: 'post',
    params: params,
    data:data
  });
}

//修改密码
export function ChangePWD (params) {
  return request({
    url: '/api/User/ChangePWD',
    method: 'post',
    params: params,
  });
}


//获取用户基本信息
export function GetUserInfo () {
  return request({
    url: '/api/User/GetUserInfo',
    method: 'get',
  });
}

//修改用户基本信息
export function UpdateUserInfo (params) {
  return request({
    url: '/api/User/UpdateUserInfo',
    method: 'post',
    params: params,
  });
}